import api from "./api";

export const getSubscriptionPlans = async () => {
  const response = await api.get("/subscription-plans");
  return response.data;
};

export const getActiveSubscriptionPlans = async () => {
  const response = await api.get("/subscription-plans/active");
  return response.data;
};

export const createSubscriptionPlan = async (data: any) => {
  const response = await api.post("/subscription-plans", data);
  return response.data;
};

export const updateSubscriptionPlan = async (data: any) => {
  const response = await api.put("/subscription-plans", data);
  return response.data;
};

export const deleteSubscriptionPlan = async (id: number) => {
  const response = await api.delete(`/subscription-plans/${id}`);
  return response.data;
};
